import React from 'react';
import ReactDOM from 'react-dom';

import App from './containers/App';

import './css/fontawesome.min.css';
import './css/all.min.css';
import './css/select.scss';
import './common.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-calendar/dist/Calendar.css';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
